var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('div',{staticClass:"page-a4 container elevation-5",attrs:{"size":"A4","layout":"landscape"}},[(_vm.fabricOrder)?_c('export-fabric-order',{attrs:{"fabric-order":_vm.fabricOrder}}):_vm._l((_vm.oldPrototypes),function(prototype){return _c('div',{key:prototype.id},[_c('manufac-for-export',{attrs:{"prototype":prototype}})],1)})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }